import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  formatQueryParams,
  JsonApiResponseDto,
  parseJsonApiResponse,
  prepareHeaders,
  Response,
  TQueryParams,
} from 'evolve-ui';
import { TEmployeeContract } from './digital-signatures.api';

export enum EmployeeContractsStatus {
  PENDING = 3,
}

//export type TCTTCustomer = {
//  id: number;
//  name: string;
//  number: string;
//  customerStatusId: number;
//  caCodeId: number;
//};

//export type TConstCenter = {
//  id: number;
//  reference: string;
//  code: string;
//  description: string;
//  customer_id: number;
//  agency_id: number;
//};

//export type TCTTContract = {
//  startDate: string;
//  number: string;
//  customer: TCTTCustomer;
//  costCenter: TConstCenter;
//};

export const employeeContractsContractsApi = createApi({
  reducerPath: 'contracts-new',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_NEW_CONTRACTS_API_URL}`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Employee-Contracts'],
  endpoints: (builder) => ({
    getEmployeeContracts: builder.query<
      Response<TEmployeeContract>,
      TQueryParams
    >({
      providesTags: ['Employee-Contracts'],
      query: (params) => formatQueryParams(params),

      transformResponse: (res, meta, args) => {
        return parseJsonApiResponse<TEmployeeContract>(
          res as JsonApiResponseDto<TEmployeeContract>,
          meta,
          args,
          true
        );
      },
    }),
  }),
});

export const { useGetEmployeeContractsQuery } = employeeContractsContractsApi;
